import { render } from "./MatchKits.vue?vue&type=template&id=ff04b14c&scoped=true"
import script from "./MatchKits.vue?vue&type=script&lang=js"
export * from "./MatchKits.vue?vue&type=script&lang=js"

import exportComponent from "/home/user/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff04b14c"]])

export default __exports__